import api from '@/api';
// defaultTheme
import { setTheme } from '@/assets/theme/setTheme';
import consoleRouteConfigs from '@/router/console';
import menuConfig from '@/config/menuConfig';
import { routeFilter, menuFilter, listToMenuList } from '@/utils/configFilter';
// import { routeFilter, menuFilter } from '@/utils/configFilter';
import { clone } from '@/utils';

export default {
  state: {
    token: '',
    profile: {},
    permissions: [],
    hadSetRoutes: false,
    // defaultTheme
    theme: '',
  },

  getters: {
    profile: state => state.profile,
    token: state => state.token,
    profileName: state => state.profile.displayName || state.profile.name,
    profileTheme: state => state.profile.theme,
    isAdmin: state => state.profile.type === 'Admin',
    isNormal: state => state.profile.type === 'Normal',
    addRoutes: (state) => {
      const permissions = state.permissions;
      const routeConfigs = [
        ...routeFilter(consoleRouteConfigs, permissions),
      ];
      return routeConfigs;
    },
    filteredMenuList: (state, _getters, rootState) => {
      //console.log("111---------",rootState.project)
      const { projects } = rootState.project;
      // eslint-disable-next-line no-unused-vars
      const { corporation } = rootState.corporation;
      const projectList = projects.map((p) => {
        return {
          name: p.name,
          type: p.subsidiary === 0 ? 'function' : 'subsidiary',
          path: p.subsidiary === 0 ? `/projects/${p.id}` : '/index',
          icon: p.subsidiary === 0 ? 'project' : 'corporation',
          isI18n: true,
          project: p,
        };
      });

      const cloneMenuConfig = clone(menuConfig);
      const projectsMenu = cloneMenuConfig.find(item => item.name === 'projects');
      projectsMenu.children = projectList;

      const permissions = state.permissions;
      const configs = [
        ...menuFilter(cloneMenuConfig, permissions),
      ];
      const menus = listToMenuList(configs, corporation.name);

      return menus;
    },
  },

  actions: {
    // 获取验证码
    async GetVerify() {
      const { img } = await api.auth.verifyAvg();
      return { img };
    },
    // 登录
    async Login({ commit }, params) {
      const { token, user, permissions } = await api.auth.signin(params);

      if (!token || !user) {
        throw new Error('授权信息不正确');
      }
      const sessionUser = JSON.parse(sessionStorage.getItem('user'));
      if (sessionUser && sessionUser.id !== user.id) {
        sessionStorage.removeItem('currentProject');
      }

      sessionStorage.setItem('Authorization', token);
      sessionStorage.setItem('user', JSON.stringify(user));
      commit('SET_TOKEN', token);
      commit('SET_PROFILE', user);
      commit('SET_PERMISSIONS', permissions);
      return { token, user, permissions };
    },

    // 初始化用户信息，从缓存获取内容
    async InitUserData({ commit }) {
      if (sessionStorage.profile && sessionStorage.getItem('Authorization')) {
        const profile = JSON.parse(sessionStorage.profile);
        commit('SET_PROFILE', profile);

        const permissions = JSON.parse(sessionStorage.permissions);
        commit('SET_PERMISSIONS', permissions);

        const authorization = sessionStorage.getItem('Authorization');
        commit('SET_TOKEN', authorization);

        return profile;
      }
      return Promise.reject(new Error('账号未登录'));
    },

    // 登出
    LogOut({ commit }) {
      commit('SET_TOKEN', '');
      sessionStorage.removeItem('Authorization');
      window.sessionStorage.clear();
    },

    // 改变用户主题
    ChangeTheme({ commit }, theme) {
      commit('SET_THEME', theme);
      setTheme(theme);
      // 将用户改变的主题数据，存到缓存的profile里
      const profile = JSON.parse(sessionStorage.getItem('profile'));
      sessionStorage.setItem('profile', JSON.stringify({ ...profile, theme }));
    },
  },

  mutations: {
    SET_TOKEN(state, Authorization) {
      state.token = Authorization;
    },
    SET_PROFILE(state, data) {
      state.profile = data;
      sessionStorage.profile = JSON.stringify(data);
    },
    SET_PERMISSIONS(state, permissions) {
      state.permissions = permissions;
      sessionStorage.permissions = JSON.stringify(permissions);
    },
    SET_THEME(state, theme) {
      state.theme = theme;
    },
    SET_ROUTES(state, flag = true) {
      state.hadSetRoutes = flag;
    },
  },
};
